/* eslint-disable max-len */
import * as ActionTypes from '../components/actions/types';

const initialState = {
  chatWindowOpen: false,
  chatProfileId: '',
  chatToken: '',
  chatDetail: [],
  currentChatRoom: '',
  groupChatWindowOpen: false,
  scroll: false,
  currentLength: 0,
  disable: false,
  dialogOpen: false,
  currentLC: '',
  LCDetail: []
};
function chatReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.USER_CHAT_LOGIN:
      return {
        ...state,
        chatToken: action.payload.chatToken,
        chatProfileId: action.payload.chatProfileId
      };
    case ActionTypes.USER_GET_CHATDETAIL:
      return {
        ...state,
        chatDetail: action.payload
      };
    case ActionTypes.CLOSE_CURRENT_CHAT_WINDOW:
      return {
        ...state,
        chatWindowOpen: false,
        currentChatRoom: ''
      };
    case ActionTypes.CLOSE_CURRENT_GROUPCHAT_WINDOW:
      return {
        ...state,
        groupChatWindowOpen: false,
        currentChatRoom: ''
      };
    case ActionTypes.ENTER_CHAT_ROOM: {
      const newState = JSON.parse(JSON.stringify(state));
      newState.chatWindowOpen = true;
      newState.groupChatWindowOpen = false;
      newState.currentChatRoom = action.payload;
      const index = newState.chatDetail.findIndex(chat => chat.chatId === newState.currentChatRoom);
      newState.chatDetail[index].unreadCount = 0;
      return newState;
    }
    case ActionTypes.ENTER_GROUPCHAT_ROOM: {
      const newState = JSON.parse(JSON.stringify(state));
      newState.chatWindowOpen = false;
      newState.groupChatWindowOpen = true;
      newState.currentChatRoom = action.payload;
      const index = newState.chatDetail.findIndex(chat => chat.chatId === newState.currentChatRoom);
      newState.chatDetail[index].unreadCount = 0;
      return newState;
    }
    case ActionTypes.CREATE_NEW_CHATROOM: {
      return {
        ...state,
        chatWindowOpen: true,
        groupChatWindowOpen: false,
        currentChatRoom: action.payload
      };
    }
    case ActionTypes.CREATE_NEW_GROUPCHATROOM: {
      return {
        ...state,
        chatWindowOpen: false,
        groupChatWindowOpen: true,
        currentChatRoom: action.payload
      };
    }
    case ActionTypes.ADD_NEW_CHAT: {
      if (state.chatDetail.length !== 0) {
        const result = state.chatDetail.find(element => element.chatId === action.payload.chatId);
        if (result) {
          return { ...state };
        }
      }
      const newState = JSON.parse(JSON.stringify(state));
      newState.chatDetail.push(action.payload);
      newState.disable = false;
      return newState;
    }
    case ActionTypes.RECEIVE_NEW_MESSAGE: {
      const message = action.payload;
      const {
        chatId, author, content, imageUrl, time
      } = message;
      if (state.chatDetail.length !== 0) {
        const chatInfo = state.chatDetail.find(element => element.chatId === chatId);
        if (chatInfo) {
          const result = chatInfo.messages.find(element => element.author === author && element.content && element.time === time);
          if (result) {
            return { ...state };
          }
        }
      }
      const newMessage = {
        author,
        content,
        imageUrl,
        time
      };
      const newState = JSON.parse(JSON.stringify(state));
      const num = state.chatDetail.findIndex(chatInfo => chatInfo.chatId === chatId);
      if (chatId === state.currentChatRoom) {
        newState.chatDetail[num].messages.push(newMessage);
      } else {
        newState.chatDetail[num].messages.push(newMessage);
        newState.chatDetail[num].unreadCount = state.chatDetail[num].unreadCount + 1;
      }
      return newState;
    }
    case ActionTypes.RECEIVE_NEW_LCMESSAGE: {
      const message = action.payload;
      const { chat } = message;
      if (chat === state.currentLC) {
        const newState = JSON.parse(JSON.stringify(state));
        newState.LCDetail.push(message);
        return newState;
      }
      return state;
    }
    case ActionTypes.UPDATE_USER_STATUS: {
      const message = action.payload;
      const { chatProfileId, status } = message;
      const newState = JSON.parse(JSON.stringify(state));
      const num = state.chatDetail.findIndex(chatInfo => chatInfo.users[0].chatProfileId === chatProfileId || chatInfo.users[1].chatProfileId === chatProfileId);
      if (num !== -1) {
        const chatInfo = newState.chatDetail[num];
        const userNum = chatInfo.users.findIndex(user => user.chatProfileId === chatProfileId);
        newState.chatDetail[num].users[userNum].userStatus = status;
        return newState;
      }
      return state;
    }
    case ActionTypes.UPDATE_TO_FULL_HISTORY: {
      const newState = JSON.parse(JSON.stringify(state));
      const index = state.chatDetail.findIndex(chat => chat.chatId === state.currentChatRoom);
      newState.scroll = true;
      newState.currentLength = state.chatDetail[index].messages.length;
      newState.chatDetail[index].messages = action.payload;
      return newState;
    }
    case ActionTypes.TO_NORMAL_SCROLL: {
      return {
        ...state,
        scroll: false,
        currentLength: 0
      };
    }
    case ActionTypes.DISABLE_MESSAGE: {
      return {
        ...state,
        disable: true
      };
    }
    case ActionTypes.OPEN_MOBILE_CHATWINDOW: {
      return {
        ...state,
        chatWindowOpen: true,
        dialogOpen: true
      };
    }
    case ActionTypes.OPEN_DIALOG: {
      return {
        ...state,
        dialogOpen: !state.dialogOpen
      };
    }
    case ActionTypes.SET_LC_STATUS: {
      const { message } = action;
      const history = [];
      for (let i = message.length - 1; i >= 0; i--) {
        const msg = {
          author: message[i].author,
          content: message[i].content,
          chat: message[i].chat
        };
        history.push(msg);
      }
      return {
        ...state,
        currentLC: action.chatId,
        LCDetail: history
      };
    }
    case ActionTypes.RESET_REDUCER_GROUP:
      return { ...initialState };
    default: {
      return state;
    }
  }
}

export default chatReducer;



// WEBPACK FOOTER //
// ./src/reducers/chat.js